import { useContext, useEffect, useRef, useState } from 'react';

//helpers
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';
import { ActivityFeedContext } from '@/context/ActivityFeedContext';
import { formatDateFilterContent } from  '@/helpers/ActivityFeed';



const UseDateFilter = () => {
    const containerRef = useRef<any>()
    
    const { filterDates, setFilterDates } = useContext(ActivityFeedContext);
    const [showCalendar, setShowCalendar] = useState<boolean>(false);

    const filterButtonText = "Select Date(s)";
    const filterAriaLabel = 'Filter the Activity Feed By Dates';
    const showClearDatesButton = filterDates.length >= 1;
    const clearDateButtonText = formatDateFilterContent(filterDates);
    const clearDateAriaLabel = 'Clear date filters';

    useClickAwayClose(showCalendar, containerRef, () => setShowCalendar(false))

    useEffect(() => {
        if(filterDates.length === 2) {
            setTimeout(() => setShowCalendar(false), 500);
        }
    },[filterDates])

    function onClickFilterButton() {
        setShowCalendar(!showCalendar);
    }

    function onClickClearDates() {
        setFilterDates([]);
    }

    return { containerRef, filterButtonText, filterAriaLabel, onClickFilterButton, clearDateButtonText, showClearDatesButton, clearDateAriaLabel, onClickClearDates, showCalendar, filterDates, setFilterDates }
};
export default UseDateFilter